module.exports = __webpack_public_path__ + "img/avatar1.72e0199c.png";